import { render, staticRenderFns } from "./specs.vue?vue&type=template&id=2a52677b&scoped=true"
import script from "./specs.vue?vue&type=script&lang=js"
export * from "./specs.vue?vue&type=script&lang=js"
import style0 from "./specs.vue?vue&type=style&index=0&id=2a52677b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52677b",
  null
  
)

export default component.exports